import React from 'react';
import { withRouter } from 'react-router-dom';

import CloseButton from './CloseButton';

export default withRouter(({history}) => (
    <CloseButton onClick={history.goBack} />
));
